/***
 * @Author: zsh
 * @Date: 2020-06-23 10:06:43
 * @LastEditors: zsh
 * @LastEditTime: 2020-06-30 00:51:48
 * @FilePath: /official-website/src/router/index.js
 **/
import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err);
// };
export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "首页"
          }
        },
        {
          path: "/product",
          name: "product",
          component: resolve => require(["@/view/Product"], resolve),
          meta: {
            title: "产品中心"
          }
        },
        {
          path: "/product/details",
          name: "product-details",
          component: resolve => require(["@/view/ProductDetails"], resolve),
          meta: {
            title: "产品中心"
          }
        },
        {
          path: "/program",
          name: "program",
          component: resolve => require(["@/view/Program"], resolve),
          meta: {
            title: "解决方案"
          }
        },
        {
          path: "/case",
          name: "case",
          component: resolve => require(["@/view/Case"], resolve),
          meta: {
            title: "项目案例"
          }
        },
        {
          path: "/case/details",
          name: "case-details",
          component: resolve => require(["@/view/CaseDetails"], resolve),
          meta: {
            title: "项目案例"
          }
        },
        {
          path: "/news",
          name: "news",
          component: resolve => require(["@/view/News"], resolve),
          meta: {
            title: "新闻资讯"
          }
        },
        {
          path: "/news/details",
          name: "news-details",
          component: resolve => require(["@/view/NewsDetails"], resolve),
          meta: {
            title: "新闻资讯"
          }
        },
        {
          path: "/about",
          name: "about",
          component: resolve => require(["@/view/About"], resolve),
          meta: {
            title: "关于SIMBA"
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js